<app-container-uif>
  <div class="min-h-screen flex justify-center items-center">
    <div class="m-auto w-80">
      <div class="flex flex-col md:flex-row gap-11 items-center">
        <div>
          <i-lucide [img]="icon" size="60"></i-lucide>
        </div>
        <div class="text-center md:text-left">
          <h2 class="text-3xl">Nicht gefunden</h2>
          <p class="mt-3">Diese Seite konnte nicht gefunden werden.</p>
        </div>
      </div>
    </div>
  </div>
</app-container-uif>
